import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from '../../Shared';

let BsMoistureConditionValueWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Moisture Condition Value Measurements">
        <MeasurementsSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <PageSection heading="Results">
        <ResultsSection chartNamePrefix="mcvChart" />
      </PageSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsMoistureConditionValueWorksheet.qestIds = [ids.moistureConditionValue.BS_1377_2_Clause_13_4.rev2022];
BsMoistureConditionValueWorksheet = withInjectedProps(BsMoistureConditionValueWorksheet);

export { BsMoistureConditionValueWorksheet };
export default BsMoistureConditionValueWorksheet;
